module.exports = __webpack_public_path__ + "img/ent-onsite.bf9e70b4.jpg";